import {
  IonPage,
  IonHeader,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
} from "@ionic/react";
import React from "react";
import TopLeftUserName from "../components/TopLeftUserName";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  currentAssessmentState,
  listOfAssessmentsState,
  networkConnectionStatus,
} from "../data/atoms";
import { useHistory } from "react-router";
import { Assessment } from "../models/AssessmentRelated/Assessment";

const AssessmentsList: React.FC = () => {
  const getListOfAssessments = useRecoilValue(listOfAssessmentsState);
  const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
    currentAssessmentState,
  );
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );

  function formateDate(date: any) {
    let options: any = {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    };
    let d = new Date(date);
    return d?.toLocaleDateString("en-US", options);
  }
  function formatTime(date: any) {
    var hours = date?.getHours();
    var minutes = date?.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }
  let history = useHistory();
  const goToReportPage = (report: any) => {
    debugger;
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setcurrentAssessmentState((prevState: Assessment) => ({
      ...prevState,
      patientId: report.patientId,
      masterTestId: report.masterTestID,
      masterVisitId: report.masterVisitId,
      assessmentType: report.vbTestLookupId,
      testId: report.vbTestID,
      visitId: report.visitId,
      testDateTime: report.visitDate,
      isViewFullSummary: true,
      workstationId: report.workstationId,
      locationId: report.locationId,
    }));
    setTimeout(() => {
      history.replace("/patient-assessment-summary", {
        pageHeaderText: "Full Visit Summary",
        isAssessmentCompleted: false,
      });
    }, 200);
  };
  return (
    <IonPage placeholder={undefined}>
      <TopLeftUserName headerText={"Assessment List"}></TopLeftUserName>
      <IonContent
        className="keybordOffset slide-in-right"
        placeholder={undefined}
      >
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            {
              <IonCol className="col-sec" placeholder={undefined}>
                {getListOfAssessments.assessments.map((assessment: any) => {
                  return (
                    <div className="assessment-list-main-wrap">
                      <div className="assessment-list-inner-wrap">
                        <ul>
                          <li>
                            <strong>Assessment Type</strong>
                            <span className="right-side">
                              <strong>
                                {(() => {
                                  switch (assessment.vbTestLookupId) {
                                    case 22:
                                      return "Gait";
                                    case 55:
                                      return "Upper Body AROM";
                                    case 51:
                                      return "Red Light Green Light";
                                    case 50:
                                      return "Apple Frenzy";
                                    case 21:
                                      return "Balloon Popper";
                                    case 41:
                                      return "Veggie Slicer";
                                    case 31:
                                      return "Time Up and Go";
                                    case 2:
                                      return "Functional Reach";
                                    case 1:
                                      return "mCTSIB";
                                    default:
                                      return "5XSTS";
                                  }
                                })()}
                              </strong>
                            </span>
                          </li>
                          <li>
                            <strong>
                              <span>
                                {formateDate(
                                  new Date(assessment?.testDateTime),
                                )}
                              </span>
                            </strong>
                            <span className="right-side">
                              <span>
                                {formatTime(new Date(assessment?.testDateTime))}
                              </span>
                            </span>
                          </li>
                          <li>
                            Performed by
                            <span className="right-side">
                              Dr. {assessment.therapistName}
                            </span>
                          </li>
                        </ul>
                        <button
                          className="genertic-btn blue-outline-btn"
                          onClick={() => {
                            goToReportPage(assessment);
                          }}
                        >
                          <svg
                            width="19"
                            height="18"
                            viewBox="0 0 19 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.4502 16.3125C14.7596 16.3125 15.0127 16.0594 15.0127 15.75V5.625H12.2002C11.5779 5.625 11.0752 5.12227 11.0752 4.5V1.6875H5.4502C5.14082 1.6875 4.8877 1.94062 4.8877 2.25V15.75C4.8877 16.0594 5.14082 16.3125 5.4502 16.3125H14.4502ZM3.2002 2.25C3.2002 1.00898 4.20918 0 5.4502 0H11.2686C11.8662 0 12.4393 0.235547 12.8611 0.657422L16.0428 3.83906C16.4646 4.26094 16.7002 4.83398 16.7002 5.43164V15.75C16.7002 16.991 15.6912 18 14.4502 18H5.4502C4.20918 18 3.2002 16.991 3.2002 15.75V2.25Z"
                              fill="#005A75"
                            />
                          </svg>
                          View Assessment
                        </button>
                      </div>
                    </div>
                  );
                })}
              </IonCol>
            }
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
export default AssessmentsList;
